import React, { Component } from 'react';
import { facultyData } from '../facultyData';
interface ResearchTemplateProps {
  data: typeof facultyData;
  showQR: boolean;
  showPageNumbers: boolean;
}
export function ResearchTemplate({
  data,
  showQR,
  showPageNumbers
}: ResearchTemplateProps) {
  const totalCitations = data.publications.reduce((sum, pub) => sum + pub.citations, 0);
  return <div className="font-serif-cv text-slate-900 leading-relaxed" data-id="element-115">
      {/* Header */}
      <div className="flex items-center justify-between mb-8 pb-6 border-b-4 border-gold" data-id="element-116">
        <div data-id="element-117">
          <h1 className="text-4xl font-bold text-navy mb-1" data-id="element-118">
            {data.personalInfo.fullName}
          </h1>
          <p className="text-xl text-slate-700" data-id="element-119">
            {data.personalInfo.designation}, {data.personalInfo.department}
          </p>
          <div className="flex space-x-4 mt-2 text-sm text-slate-600" data-id="element-120">
            <span data-id="element-121">{data.personalInfo.email}</span>
            <span data-id="element-122">•</span>
            <span data-id="element-123">{data.personalInfo.phone}</span>
          </div>
        </div>

        {/* Research Stats Block */}
        <div className="bg-slate-50 p-4 border border-slate-200 rounded-lg text-center min-w-[120px]" data-id="element-124">
          <div className="text-3xl font-bold text-navy" data-id="element-125">
            {data.publications.length}
          </div>
          <div className="text-xs font-bold text-slate-500 uppercase tracking-wider" data-id="element-126">
            Publications
          </div>
          <div className="text-xl font-bold text-gold mt-2" data-id="element-127">
            {totalCitations}
          </div>
          <div className="text-xs font-bold text-slate-500 uppercase tracking-wider" data-id="element-128">
            Citations
          </div>
        </div>
      </div>

      <div className="space-y-8" data-id="element-129">
        <section data-id="element-130">
          <h2 className="text-xl font-bold text-navy uppercase tracking-wider mb-4 flex items-center" data-id="element-131">
            <span className="w-8 h-0.5 bg-gold mr-3" data-id="element-132"></span>
            Research Focus
          </h2>
          <p className="text-slate-700 mb-3" data-id="element-133">{data.biography}</p>
          <div className="flex flex-wrap gap-2" data-id="element-134">
            {data.researchInterests.map((interest, i) => <span key={i} className="px-3 py-1 bg-slate-100 text-slate-700 text-sm rounded-full border border-slate-200" data-id="element-135">
                {interest}
              </span>)}
          </div>
        </section>

        <section data-id="element-136">
          <h2 className="text-xl font-bold text-navy uppercase tracking-wider mb-4 flex items-center" data-id="element-137">
            <span className="w-8 h-0.5 bg-gold mr-3" data-id="element-138"></span>
            Funded Projects
          </h2>
          <div className="space-y-4" data-id="element-139">
            {data.projects.map((project, i) => <div key={i} className="border-l-2 border-slate-200 pl-4" data-id="element-140">
                <div className="flex justify-between items-start" data-id="element-141">
                  <h3 className="font-bold text-slate-900" data-id="element-142">{project.title}</h3>
                  <span className="text-sm font-bold text-slate-600 whitespace-nowrap ml-4" data-id="element-143">
                    {project.period}
                  </span>
                </div>
                <div className="text-sm text-slate-700 mt-1" data-id="element-144">
                  <span className="font-medium text-navy" data-id="element-145">{project.role}</span>{' '}
                  • Funded by {project.fundingSource}
                </div>
              </div>)}
          </div>
        </section>

        <section data-id="element-146">
          <h2 className="text-xl font-bold text-navy uppercase tracking-wider mb-4 flex items-center" data-id="element-147">
            <span className="w-8 h-0.5 bg-gold mr-3" data-id="element-148"></span>
            Selected Publications
          </h2>
          <div className="space-y-3" data-id="element-149">
            {data.publications.map((pub, i) => <div key={i} className="flex text-sm" data-id="element-150">
                <span className="font-bold text-slate-400 w-6 shrink-0" data-id="element-151">
                  [{i + 1}]
                </span>
                <div data-id="element-152">
                  <span className="font-medium" data-id="element-153">{pub.authors}</span> ({pub.year}
                  ). "{pub.title}". <span className="italic" data-id="element-154">{pub.venue}</span>.
                  <span className="text-teal ml-2" data-id="element-155">
                    ({pub.citations} citations)
                  </span>
                </div>
              </div>)}
          </div>
        </section>

        <section data-id="element-156">
          <h2 className="text-xl font-bold text-navy uppercase tracking-wider mb-4 flex items-center" data-id="element-157">
            <span className="w-8 h-0.5 bg-gold mr-3" data-id="element-158"></span>
            Academic Background
          </h2>
          <div className="grid grid-cols-2 gap-4" data-id="element-159">
            {data.education.map((edu, i) => <div key={i} data-id="element-160">
                <div className="font-bold text-slate-900" data-id="element-161">{edu.degree}</div>
                <div className="text-sm text-slate-700" data-id="element-162">
                  {edu.institution}, {edu.year}
                </div>
              </div>)}
          </div>
        </section>
      </div>

      {/* Footer Elements */}
      {showQR && <div className="absolute bottom-12 right-12" data-id="element-163">
          <img src={`https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=${encodeURIComponent(data.personalInfo.profileUrl)}&color=1C4370&bgcolor=ffffff`} alt="Profile QR" className="w-20 h-20" data-id="element-164" />
        </div>}

      {showPageNumbers && <div className="absolute bottom-8 left-0 right-0 text-center text-xs text-slate-400 font-sans" data-id="element-165">
          Page 1 of 2
        </div>}
    </div>;
}